import actions from '../actions/contactOwnerFormActions';
import createReducer from '../utils/createReducer';
import ContactOwnerFormRecord from '../records/contactOwnerFormRecord';
import ListingActions from '../actions/listingActions';

const initialState = new ContactOwnerFormRecord();

const actionHandlers = {
    [actions.CONTACT_OWNER_FORM_CHANGED](state, {payload = {}}) {
        const {
            fieldsChanged,
            fieldsChanged: {
                invalid
            }
        } = payload;

        if (invalid) {
            throw new Error('Tried to change `invalid` field. Use CONTACT_OWNER_FORM_FIELD_VALID instead');
        }

        return state.merge({
            ...fieldsChanged
        });
    },

    [actions.CONTACT_OWNER_FORM_FIELD_TOUCHED](state, {payload = {}}) {
        const {field} = payload;

        return state.merge({
            touched: state.touched.add(field)
        });
    },
    [actions.CONTACT_OWNER_FORM_VALID](state, {payload = {}}) {
        const {isFormValid} = payload;

        return state.merge({
            isFormValid
        });
    },
    [actions.CONTACT_OWNER_FORM_FIELD_VALID](state, {payload = {}}) {
        const {field, isValid} = payload;

        return state.merge({
            invalid: isValid ? state.invalid.remove(field) : state.invalid.add(field)
        });
    },
    [actions.SCROLL_TOP](state, {payload = {}}) {
        const {
            scrollTop
        } = payload;
        return state.merge({scrollTop});
    },
    [ListingActions.FETCH_USER_DATA_SUCCESS](state, {payload}) {
        const {
            userData
        } = payload;

        return state.merge({...userData});
    }
};

export default createReducer(actionHandlers, initialState);
